import { FirmasConLabels, schemaFirmasConLabels } from '../types/firma'
import { getEndpointBySistema } from './httpSistema'
import { HttpAxiosRequest } from 'src/http/httpAxiosBase'

export const getFirmas = (codSistema: number, idOperacion: number): Promise<FirmasConLabels> => {
    const endpoint = `${getEndpointBySistema(codSistema)}/${idOperacion}/firmas`

    // TODO: objeto/enum con rutas

    return HttpAxiosRequest.get(endpoint)
        .then(response => {
            const parsed = schemaFirmasConLabels.safeParse(response)

            if (!parsed.success) {
                console.error(parsed.error.issues)

                return Promise.reject('Error de validación.')
            }

            return Promise.resolve(parsed.data)
        })
        .catch(error => {
            console.error(error)

            return Promise.reject('Error de red.')
        })
}
